import { withStyles } from '@mui/styles'
import { Tooltip } from '@mui/material'
import { formatMinutesAsTime } from '../../../utils/time'

const BlueTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: props =>
      props.disabled ? '#ccc' : theme.palette.primary.main,
    color: props => (props.disabled ? '#666' : theme.palette.common.white),
  },
  popper: {
    zIndex: '1',
  },
}))(Tooltip)

const ValueLabelComponent = props => {
  const { children, open, value, disabled } = props

  return (
    <BlueTooltip
      open={open}
      enterTouchDelay={0}
      placement="top"
      title={formatMinutesAsTime(value)}
      disabled={disabled}
    >
      {children}
    </BlueTooltip>
  )
}

export default ValueLabelComponent
